module.exports = function() {
  return new Worker(__webpack_public_path__ + "4bb17633faad989339af.worker.js");
};